import { assert } from '@varos/util-typescript';
import { ReportingLoaderBaseConfig } from '../../base';
import { ResourceBlockLoader } from './resourceBlockInterface';
import { ResourceBlockAggregate } from './resourceBlockModel';

export function createResourceBlockLoader(
    config: ReportingLoaderBaseConfig
): ResourceBlockLoader {
    const {
        repository: { research },
    } = config;
    return {
        useLoad(context, props): ResourceBlockAggregate {
            const blockQuery = research.block.useLookup(
                context,
                {
                    id: props.block,
                },
                {
                    suspense: true,
                }
            );
            assert(blockQuery.status === 'success', 'expected suspense');
            assert(blockQuery.data.data.kind === 'resource', 'expected resource block');
            const resourceQuery = research.resource.useLookup(
                context,
                {
                    resourceId: blockQuery.data.data.resource,
                },
                {
                    suspense: true,
                    refetchInterval(data, query) {
                        if (data?.status === 'pending') {
                            return 2500;
                        }
                        return false;
                    },
                }
            );
            assert(resourceQuery.status === 'success', 'expected suspense');
            return {
                block: blockQuery.data,
                custom: blockQuery.data.data,
                resource: resourceQuery.data,
            };
        },
    };
}
